module.exports = __webpack_public_path__ + "static/canvas1-f2db0f224d6635fd25f6177111fe3d9a.png";